
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

/**
 * @name roundStake
 * @description function rounding stake
 * @param {number} stake
 * @returns {number}
 * */
import { Component } from 'react';
import { connect } from 'react-redux';
import { SwarmDataMixin } from '../../../../dev/mixins/swarmDataMixin';
import { UIMixin } from '../../../../dev/mixins/uiMixin';
import { UIOpen, UIClose, changeOddsFormat } from "../../../../dev/actions/ui";
import Helpers from "../../../../dev/helpers/helperFunctions";
import { GetBetslipData } from "../../../../dev/helpers/selectors";
import PropTypes from 'prop-types';
import Config from "../../../../dev/config/main";
import { TOGGLE_VIRTUAL_KEYBOARD } from "../../../../dev/actions/actionTypes";
import {
    BetslipClear, BetslipRemove, BetslipSetType, BetslipToggleQuickBet, BetslipAcceptChanges,
    BetslipSetStake, BetslipSetUnitStake, BetslipPlaceBet, BetslipGetEventMaxBet, BetslipSetEachWayMode,
    BetslipSetSystemOpt, BetslipSetAcceptOpt, BetslipSetInclInSysCalc, BetslipResetStatus, BetslipToggleSuperBet,
    BetslipToggleFreeBet, BetslipSelectFreeBet, BetslipToggleBookingBet, BetslipBookBet, BetslipBetFailed, BetslipLoadFreeBets,
    BetslipRepeatBet, BetslipClearLastBet, BetslipSetActiveEvent, BetslipSetSystemActiveInput, BetslipSetOfferedPrice
} from "../../../../dev/actions/betslip";
import { mathCuttingFunction } from "../../../../dev/helpers/filters";
import { BETSLIP_TYPE_SINGLE, BETSLIP_TYPE_EXPRESS, BETSLIP_TYPE_SYSTEM, addEventCompareConflicts, getDivisionCoefficient, superBetWatcher, BetslipTypes } from "../../../../dev/helpers/sport/betslip";
import _ from 'lodash';
import { BetPriceChangeEnum } from '../../../constants/enums/betPriceChange';

var rounding;

/**
 * @name roundStake
 * @description function rounding stake
 * @param {number} stake
 * @returns {number}
 * */

let roundStake = stake => {
    let factor = Math.pow(10, rounding);
    return Math.trunc(mathCuttingFunction((parseFloat(stake) || 0) * factor)) / factor;
};

class Betslip extends Component {
    constructor(props) {
        super(props);
        this.dragged = false;
        this.state = { betslipCollapsed: true, };
        this.scrollBetSlipToElement = this.scrollBetSlipToElement.bind(this);
        this.setBetslipType = this.setBetslipType.bind(this);
        this.placeBet = this.placeBet.bind(this);
        this.repeatBet = this.repeatBet.bind(this);
        this.bookBet = this.bookBet.bind(this);
        this.selectFreeBet = this.selectFreeBet.bind(this);
        this.resetBetslipStatus = this.resetBetslipStatus.bind(this);
        this.acceptChanges = this.acceptChanges.bind(this);
        this.setAcceptOptions = this.setAcceptOptions.bind(this);
        this.toggleEachWayMode = this.toggleEachWayMode.bind(this);
        this.includeInSystemCalc = this.includeInSystemCalc.bind(this);
        this.saveQuickBetStake = this.saveQuickBetStake.bind(this);
        this.openKeyBoard = this.openKeyBoard.bind(this);
        this.setUpKeyboard = this.setUpKeyboard.bind(this);
        this.hideKeyboard = this.hideKeyboard.bind(this);
        this.setStake = this.setStake.bind(this);
        this.setOfferedPrice = this.setOfferedPrice.bind(this);
        this.setQuickBetStake = this.setQuickBetStake.bind(this);
        this.setUnitStake = this.setUnitStake.bind(this);
        this.setSameStakeOnOtherEvents = this.setSameStakeOnOtherEvents.bind(this);
        this.getMaxStake = this.getMaxStake.bind(this);
        this.toggleBetslipSettings = this.toggleBetslipSettings.bind(this);
        this.toggleQuickBet = this.toggleQuickBet.bind(this);
        this.toggleSuperBet = this.toggleSuperBet.bind(this);
        this.toggleBookingBet = this.toggleBookingBet.bind(this);
        this.toggleFreeBet = this.toggleFreeBet.bind(this);
        this.openQuickBetStake = this.openQuickBetStake.bind(this);
        this.removeFromBetslip = this.removeFromBetslip.bind(this);
        this.clearBetslip = this.clearBetslip.bind(this);
        this.changeOddsFormat = this.changeOddsFormat.bind(this);
        this.betslipHandleClicks = this.betslipHandleClicks.bind(this);
        this.setBetslipSettings = this.setBetslipSettings.bind(this);
        this.getSystemPossibleMin = this.getSystemPossibleMin.bind(this);
        this.scroll = this.scroll.bind(this);
        this.openBetslip = this.openBetslip.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.draggedStop = this.draggedStop.bind(this);
        this.toggleExpandBetslip = this.toggleExpandBetslip.bind(this);
        this.setActiveEvent = this.setActiveEvent.bind(this)
        this.setSystemActiveInput = this.setSystemActiveInput.bind(this)
    }
    /**
     * @name scrollBetSlipToElement
     * @description virtual keyboard scroll betslip to element
     * @param {Object} e
     * @returns {undefined}
     * */
    scrollBetSlipToElement(e) {
        let pos = e.clientY,
            offsetHeight = this.betslipContainer.offsetHeight;

        offsetHeight - pos < 85 &&
            setTimeout(() => {
                this.betslipContainer.scrollTop = this.betslipContainer.scrollTop + (85 - (offsetHeight - pos));
            }, 100); // use timeout to scroll after the keyboard is opened
    }

    /**
     * @name placeBet
     * @description place bet function
     * @returns {undefined}
     * */
    placeBet(localBetslipHorseTypeOnlyTryCastForCast = null) {
        let freeBet = this.props.user.profile && this.props.user.profile.has_free_bets && this.props.betslip.freeBet; //eslint-disable-line react/prop-types
        let isConfirmed = false;
        this.props.dispatch(BetslipPlaceBet({ ...this.props.betslip, localBetslipHorseTypeOnlyTryCastForCast }, this.props.currency, freeBet, this.props.user.profile && this.props.user.profile, null, this.props.terminal, this.props.user.authData, this.props.loyalCard && this.props.loyalCard, this.props.ui.oddsFormat, isConfirmed)); //eslint-disable-line react/prop-types
    }

    repeatBet() {
        clearTimeout(this.lastBetClearTimeOut);
        this.lastBetClearTimeOut = null;
        this.props.dispatch(BetslipRepeatBet());
    }

    /**
     * @name handleDrag
     * @description variable this.dragged set true when betslip dragged
     * @returns {undefined}
     * */
    handleDrag() {
        if (!this.dragged) {
            this.dragged = true;
        }
    }
    /**
     * @name draggedStop
     * @description variable this.dragged set false when betslip stopped dragged
     * @returns {undefined}
     * */
    draggedStop() {
        if (this.dragged) {
            setTimeout(() => {
                this.dragged = false;
            }, 1);
        }
    }

    toggleExpandBetslip() {
        this.setState({ betslipCollapsed: !this.state.betslipCollapsed });
    }

    /**
     * @name bookBet
     * @description booking bet function
     * @returns {undefined}
     * */
    bookBet(posWin, expOdds, localBetslipHorseTypeOnlyTryCastForCast = null) {
        let betslip;
        betslip = { ...this.props.betslip, localBetslipHorseTypeOnlyTryCastForCast };
        let betSlipData = { betslip, posWin, expOdds };
        this.props.dispatch(BetslipBookBet(betSlipData)); //eslint-disable-line react/prop-types
    }

    /**
     * @name selectFreeBet
     * @description select free bets in betslip
     * @param id (free bet id)
     * @param amount (free bet amount)
     * @returns {Function} action dipatcher (dispatch bet id and amount)
     * */
    selectFreeBet(id, amount) {
        return () => {
            this.props.dispatch(BetslipSelectFreeBet(id, amount));
        };
    }

    /**
     * @name resetBetslipStatus
     * @description clear betslip notifications
     * @returns {Function} ()
     * */
    resetBetslipStatus() { //clears all notifications
        this.props.dispatch(BetslipResetStatus());
    }

    /**
     * @name acceptChanges
     * @description accept bet changes
     * @returns {undefined}
     * */
    acceptChanges() {
        this.props.dispatch(BetslipAcceptChanges());
    }

    /**
     * @name setAcceptOptions
     * @description event accept option
     * @param {object} event
     * @returns {undefined}
     * */
    setBetslipSettings(priceChangeValue = Config.betting.acceptOddDefaultType) {
        this.props.dispatch(BetslipSetAcceptOpt(priceChangeValue));
        this.props.uiClose("settingsBets")();
    }

    /**
     * @name setBetslipType
     * @description function set betslip type
     * @param {object} event
     * @returns {undefined}
     * */
    setBetslipType(value) {
        return () => {
            const parsedValue = parseInt(value, 10);

            if (parsedValue === BETSLIP_TYPE_SINGLE) {
                this.props.dispatch(BetslipSetActiveEvent(+Object.keys(this.props.betslip.events)[0]))
            } else {
                this.props.dispatch(BetslipSetActiveEvent(null))
            }
            if (this.props.betslip.acceptPriceChanges === BetPriceChangeEnum.AcceptAnyOdds && this.props.betslip.type > BETSLIP_TYPE_EXPRESS) { //eslint-disable-line react/prop-types
                this.props.dispatch(BetslipSetAcceptOpt(BetPriceChangeEnum.AlwaysAsk));
            }

            this.props.dispatch(BetslipSetType(parsedValue));
        };
    }

    /**
     * @name toggleEachWayMode
     * @description function toggle each way stake mode
     * @returns {undefined}
     * */
    toggleEachWayMode() {
        this.props.dispatch(BetslipSetEachWayMode(!this.props.betslip.eachWayMode)); //eslint-disable-line react/prop-types
    }

    /**
     * @name includeInSystemCalc
     * @description function which is calculating system bet
     * @param {object} event
     * @returns {Function}
     * */
    includeInSystemCalc(event) {
        return (e) => this.props.dispatch(BetslipSetInclInSysCalc(!event.incInSysCalc, event.eventId));
    }

    /**
     * @name saveQuickBetStake
     * @description save quick bet stake amount
     * @returns {undefined}
     * */
    saveQuickBetStake() {
        let stake = roundStake(this.props.betslip.stake);
        if (stake) {
            this.props.dispatch(BetslipSetStake(stake));
            this.props.dispatch(UIClose("quickBetStake"));
        }
    }

    /**
     * @name openKeyBoard
     * @description open virtual keyboard
     * @param {string} currentValue
     * @param {function} changeHandler
     * @param onOpenCallback
     * @param {object} bet
     * @params e
     * @params onCloseCallback
     * @returns {undefined}
     * */
    openKeyBoard(currentValue, changeHandler, onOpenCallback, bet, e, onCloseCallback) {
        let defaultValue = currentValue;
        Config.clearStakeInputOnKeyboardOpen && changeHandler(defaultValue = "");
        this.setUpKeyboard(defaultValue.toString(), changeHandler, onOpenCallback, bet, e, onCloseCallback);
    }

    /**
     * @name setUpKeyboard
     * @description function set up virtual keyboard
     * @param {string} currentValue
     * @param {function} changeHandler
     * @param onOpenCallback
     * @param {object} bet
     * @params e
     * @params onCloseCallback
     * @returns {undefined}
     * */
    setUpKeyboard(currentValue, changeHandler, onOpenCallback, bet, e, onCloseCallback) {
        this.keyboardSettings = {
            currentValue,
            changeHandler,
            onOpenCallback,
            onCloseCallback,
            bet,
            e,
            processHandler: (stake) => parseFloat(stake).toString() === stake ? roundStake(stake) : stake,
            offset: e.target.offsetTop
        };
        setTimeout(() => {
            this.props.dispatch({ type: TOGGLE_VIRTUAL_KEYBOARD, payload: true });
        });
    }

    /**
     * @name hideKeyboard
     * @description hide virutal keyboard
     * @returns action dispatcher
     * */
    hideKeyboard() {
        delete this.keyboardSettings;
        return this.props.dispatch({ type: TOGGLE_VIRTUAL_KEYBOARD, payload: false });
    }

    /**
     * @name setStake
     * @description function set stake
     * @param event (default value null)
     * @returns {Function} action dispatcher
     * */
    setStake(event = null) {
        return (stake) => {
            const isBetslipTypeSingle = this.props.betslip.type === BETSLIP_TYPE_SINGLE
            stake = parseFloat(stake).toString() === stake ? roundStake(stake) : stake;
            if (event && isBetslipTypeSingle && this.props.betslip.eachWayMode) { //eslint-disable-line react/prop-types
                this.props.dispatch(BetslipSetUnitStake((stake / 2), event.eventId));
            }
            this.props.dispatch(BetslipSetStake(stake, (isBetslipTypeSingle ? this.props.betslip.activeEventId : event?.eventId) || null));
            //eslint-disable-next-line react/prop-types
            this.props.dispatch(BetslipSetUnitStake(roundStake((parseFloat(stake) || 0) / getDivisionCoefficient(this.props.betslip))));
        };
    }

    setOfferedPrice(event = null) {
        return (price) => {
            this.props.dispatch(BetslipSetOfferedPrice(price, event.eventId));
        }
    }

    /**
     * @name setQuickBetStake
     * @description set quick bet
     * @param stake
     * @returns {undefined}
     * */
    setQuickBetStake(stake) {
        this.props.dispatch(BetslipSetStake(stake));
    }

    /**
     * @name setUnitStake
     * @description function set unit stake
     * @param event (default value null)
     * @returns {Function}
     * */
    setUnitStake(event = null) {
        return (stake) => {
            var unitStake = parseFloat(stake).toString() === stake ? roundStake(stake) : stake;
            if (event && this.props.betslip.type === BETSLIP_TYPE_SINGLE && this.props.betslip.eachWayMode) { //eslint-disable-line react/prop-types
                this.props.dispatch(BetslipSetStake(roundStake(unitStake * 2), event.eventId));
            }
            this.props.dispatch(BetslipSetUnitStake(unitStake, event ? event.eventId : null));
            //eslint-disable-next-line react/prop-types
            this.props.dispatch(BetslipSetStake(roundStake(getDivisionCoefficient(this.props.betslip) * (parseFloat(unitStake) || 0))));
        };
    }

    /**
     * @name setSameStakeOnOtherEvents
     * @description helper function for passing stake amount to other events
     * @param {object} bet event
     * @returns {Function}
     * */
    setSameStakeOnOtherEvents(bet) {
        return () => {
            Object.keys(this.props.betslip.events).map(id => { //eslint-disable-line react/prop-types
                this.props.dispatch(BetslipSetStake(roundStake(bet.singleStake), id));
                this.props.dispatch(BetslipSetUnitStake(roundStake(bet.singleStake / 2), id));
            });
        };
    }

    setSameStakeOnNextEvents (bet) {
        return () => {
            const eventsIds = Object.keys(this.props.betslip.events)
            const currentEventIndex = eventsIds.findIndex(eventId => +eventId === bet.eventId)

            for (let eventIndex = currentEventIndex; eventIndex < eventsIds.length; eventIndex++) {
                const eventId = eventsIds[eventIndex]

                this.props.dispatch(BetslipSetStake(roundStake(bet.singleStake), eventId));
                this.props.dispatch(BetslipSetUnitStake(roundStake(bet.singleStake / 2), eventId));
            }
        }
    }

    /**
     * @anme getMaxStake
     * @description helper function to get event max bet amount
     * @param {object} event
     * @returns {Function}
     * */
    getMaxStake(events, localBetslipHorseTypeOnlyTryCastForCast = null) {
        return () => {
            if (this.staticState) { // TO DO
                this.staticState.setState({ activeStake: -1 });
            }
            this.props.dispatch(BetslipGetEventMaxBet(events, localBetslipHorseTypeOnlyTryCastForCast, this.props.terminal));
        };
    }

    /**
     * @name toggleBetslipSettings
     * @description betslip setting toggle function
     * @returns {undefined}
     * */
    toggleBetslipSettings() {
        if (this.props.ui.opened.betslipSettings) { //eslint-disable-line react/prop-types
            this.props.dispatch(UIClose("betslipSettings"));
        } else {
            this.props.dispatch(UIOpen("betslipSettings"));
        }
    }

    /**
     * @name toggleQuickBet
     * @description betslip toggle quick bet function which is opening quick bet stake
     * @returns {undefined}
     * */
    toggleQuickBet() {
        // $scope.acceptPriceChanges = '0';
        if (this.props.betslip.quickBet) { //eslint-disable-line react/prop-types
            this.openQuickBetStake();
        }
        this.props.dispatch(BetslipToggleQuickBet(!this.props.betslip.quickBet)); //eslint-disable-line react/prop-types
    }

    /**
     * @name toggleSuperBet
     * @description toggle function for super bet option in betSlip
     * @returns {undefined}
     * */
    toggleSuperBet() {
        this.props.dispatch(BetslipToggleSuperBet(!this.props.betslip.superBet)); //eslint-disable-line react/prop-types
    }

    /**
     * @name toggleBookingBet
     * @description toggle function for booking bet option in betSlip
     * @returns {undefined}
     * */
    toggleBookingBet() {
        this.props.dispatch(BetslipToggleBookingBet(!this.props.betslip.bookingBet)); //eslint-disable-line react/prop-types
    }

    /**
     * @name toggleFreeBet
     * @description toggle function for free bet option in betSlip
     * @returns {undefined}
     * */
    toggleFreeBet() {
        this.props.dispatch(BetslipToggleFreeBet(!this.props.betslip.freeBet)); //eslint-disable-line react/prop-types
    }

    setSystemActiveInput(activeInput) {
        this.props.dispatch(BetslipSetSystemActiveInput(activeInput))
    }

    setActiveEvent(eventId) {
        if (this.props.betslip.type === BETSLIP_TYPE_SINGLE)
            this.props.dispatch(BetslipSetActiveEvent(eventId))
    }
    /**
     * @name openBetslip
     * @description open and closed betslip
     * @returns {undefined}
     * */
    openBetslip() {
        !this.dragged && Helpers.toggleClassName(".main-wrapper", "betslip");
    }

    /**
     * @name toggleFreeBet
     * @description toggle function for opening quick bet
     * @returns {undefined}
     * */
    openQuickBetStake() {
        this.props.dispatch(UIOpen("quickBetStake"));
    }

    /**
     * @name removeFromBetslip
     * @description helper function for removing betSlip current event
     * @param eventId
     * @returns {Function}
     * */
    removeFromBetslip(eventId) {
        return () => {
            this.props.betslip.events && Object.keys(this.props.betslip.events).length === 1 && this.props.uiClose("betslip");//eslint-disable-line react/prop-types
            this.props.dispatch(BetslipRemove(eventId, true));
        };
    }
    /**
     * @name clearBetslip
     * @description remove all events from betSlip
     * @returns {undefined}
     * */
    clearBetslip() {
        this.props.dispatch(BetslipClear());
        this.props.dispatch(UIClose("betslip"));
    }

    /**
     * @name changeOddsFormat
     * @description change betslip odds format
     * @returns {undefined}
     * */
    changeOddsFormat() {
        if (this.refs.oddsFormatSelect.value !== this.props.preferences.lang) { //eslint-disable-line react/prop-types
            this.props.dispatch(changeOddsFormat(this.refs.oddsFormatSelect.value)); //eslint-disable-line react/prop-types
        }
    }

    /**
     * @name betslipHandleClicks
     * @description set betslip handle clicks
     * @returns {function}
     * */
    betslipHandleClicks(name) {
        return this.props.ui.opened[name] ? this.props.uiClose(name) : this.props.uiOpen(name);
    }
    getSystemPossibleMin(events, sysOptionValue, unitStake) {
        let prices = [], possibleMin = 1;
        events.forEach(event => {
            prices.push(event.price);
        });
        prices.sort((a, b) => a - b).splice(0, sysOptionValue).forEach(price => { possibleMin *= price; });
        return (possibleMin * unitStake).toString().match(/^-?\d+(?:\.\d{0,3})?/)[0];
    }
    scroll(scrollSize) {
        return () => {
            let iterator = (scrollSize > 0 ? 0.1 : -0.1);
            this.delta = this.delta || iterator;
            this.delta += iterator;
            this.betslipContainer.scrollTop += (scrollSize + this.delta);
        };
    }

    /**
     * @name setAcceptOptions
     * @description event accept option
     * @param {object} event
     * @returns {undefined}
     * */
    setAcceptOptions(event) {
        this.props.dispatch(BetslipSetAcceptOpt(parseInt(event.target.value, 10)));
        this.props.uiClose("betslipSettings");
    }

    render() {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }

    componentDidMount() {
        this.props.dispatch(BetslipToggleSuperBet(false)); // when creating a betslip component, superbet toggle should be set to false by default
        Config.betting.enableSuperBet && Config.betting.enableSuperBetAutomatically && this.props.dispatch(BetslipToggleSuperBet(true));
        this.resetBetslipStatus();
        this.props.dispatch(BetslipToggleQuickBet(false));
        this.props.dispatch(BetslipToggleBookingBet(false));

        !Config.betting.enableCounterOffer && this.props.betslip.acceptPriceChanges === BetPriceChangeEnum.CounterOffer && this.setBetslipSettings(Config.betting.acceptOddDefaultType);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        let eventsCount = Object.keys(nextProps.betslip.events);
        if ((eventsCount > 1 && nextProps.betslip.type !== this.props.betslip.type && nextProps.betslip.freeBet) ||
            (nextProps.betslip.quickBet && !this.props.betslip.quickBet) ||
            nextProps.user && nextProps.user.profile && !nextProps.user.profile.has_free_bets && nextProps.betslip.freeBet ||
            nextProps.betslip.eachWayMode !== this.props.betslip.eachWayMode && nextProps.betslip.eachWay
        ) {
            nextProps.dispatch(BetslipToggleFreeBet(false));
        } else if (nextProps.betslip.betFailed && eventsCount < 1) {
            nextProps.dispatch(BetslipBetFailed(null));
        }

        if (nextProps.betslip.type !== BETSLIP_TYPE_SINGLE && Config.betting.enableCounterOffer && nextProps.betslip.acceptPriceChanges === BetPriceChangeEnum.CounterOffer)
            this.props.dispatch(BetslipSetAcceptOpt(Config.betting.acceptOddDefaultType));

        if (Config.repeatBetInterval && nextProps.betslip.lastBet && !this.lastBetClearTimeOut) {
            this.lastBetClearTimeOut = setTimeout(() => {
                nextProps.dispatch(BetslipClearLastBet());
                this.lastBetClearTimeOut = null;
            }, Config.repeatBetInterval * 1000);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        let currentProps = this.props;
        return nextProps.user !== currentProps.user ||
            nextProps.data !== currentProps.data ||
            nextProps.betslip !== currentProps.betslip ||
            nextProps.ui !== currentProps.ui ||
            nextProps.persistentUI !== currentProps.persistentUI ||
            nextProps.ui.oddsFormat !== currentProps.ui.oddsFormat ||
            nextState !== this.state ||
            nextProps.currency !== currentProps.currency &&
            (
                nextProps.currency &&
                currentProps.currency &&
                (
                    nextProps.currency.rate !== currentProps.currency.rate ||
                    nextProps.currency.rounding !== currentProps.currency.rounding
                )
            );
    }
}

Betslip.propTypes = {
    terminal: PropTypes.object,
    user: PropTypes.object,
    betslip: PropTypes.object,
    ui: PropTypes.object,
    uiClose: PropTypes.func,
    uiOpen: PropTypes.func
};

function mapStateToProps(state) {
    return GetBetslipData(state);
}

export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: UIMixin({ Component: Betslip }),
        ComponentWillReceiveProps: function (nextProps) {
            rounding = nextProps.currency.rounding;
            // ------------------      handle adding/deleting event from betslip ---------------------------------------
            let nextCount = Object.keys(nextProps.betslip.events).length,
                prevCount = Object.keys(this.props.betslip.events).length,
                prevEventsIds = Object.keys(this.props.betslip.events),
                nextEventsIds = Object.keys(nextProps.betslip.events);
            if (nextCount !== prevCount || JSON.stringify(nextEventsIds) !== JSON.stringify(prevEventsIds) || (!this.inited && nextCount && nextCount > 0)) {
                const repeatBetAvailable = Config.enableRepeatBetButton && nextProps.betslip.lastBet;
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(() => {
                    const eventIds = Object.keys(nextProps.betslip.events).map(id => parseInt(id, 10));
                    const gameIds = Object.values(this.props.betslip.events).map(x => x.gameId);
                    if (eventIds.length === 0) {
                        this._unsubscribe(true);
                        return;
                    }

                    if (this.swarmSubscriptionRequest) {
                        this.swarmSubscriptionRequest.where.game.id["@in"] = gameIds;
                        this.swarmSubscriptionRequest.where.event.id["@in"] = eventIds;
                    } else {
                        this.swarmSubscriptionRequest = {
                            "source": "betting",

                            "what": {
                                "game": ["is_blocked"],
                                "event": ["price", "base", "type"]
                            },
                            "where": {
                                "event": { "id": { "@in": eventIds } },
                                "game": { "id": { "@in": gameIds } }
                            }
                        };
                    }

                    this.resubscribe(true);
                    !repeatBetAvailable && this.props.dispatch(BetslipSetSystemOpt(2));
                }, 1000);
                const willChangeToSingle = (nextCount === 1 || nextCount === 0) && ![40, 43].includes(nextProps.betslip.type);

                if (nextProps.betslip.type !== BETSLIP_TYPE_SINGLE && willChangeToSingle) {
                    this.props.dispatch(BetslipSetType(BETSLIP_TYPE_SINGLE));

                    const activeEventId = nextCount === 1 ? +Object.keys(nextProps.betslip.events)[0] : null;
                    this.props.dispatch(BetslipSetActiveEvent(activeEventId));
                }

                this.inited = true;
            }
            if (
                ((!this.props.user.profile &&
                    nextProps.user.profile &&
                    nextProps.user.profile.has_free_bets) ||
                    (!this.betslipLoadFreeBets && this.props.user.profile) ||
                    nextProps.betslip.type !== this.props.betslip.type ||
                    nextCount !== prevCount) &&
                ((nextProps.betslip.type === BETSLIP_TYPE_SINGLE && nextCount === 1) ||
                    nextProps.betslip.type !== BETSLIP_TYPE_SINGLE) &&
                (nextProps.user.reallyLoggedIn || nextProps.user.loggedInByRFID) &&
                nextProps.user.profile &&
                nextProps.user.profile.has_free_bets
            ) {
                if (this.timerId) {
                    clearTimeout(this.timerId);
                }
                this.timerId = setTimeout(() => {
                    this.props.dispatch(BetslipLoadFreeBets());
                }, 100);
                this.betslipLoadFreeBets = true;
            }
            // --------- switch off quickbet when closing betslip
            if (this.props.betslip.quickBet && !nextProps.ui.opened.betslip) {
                this.props.dispatch(BetslipToggleQuickBet(false));
            }

            // --------- recalculate stake for system type
            if (nextProps.betslip.type === BETSLIP_TYPE_SYSTEM && (this.props.betslip.type !== nextProps.betslip.type || nextProps.betslip.sysOptionValue !== this.props.betslip.sysOptionValue || nextCount !== prevCount)) {
                this.props.dispatch(BetslipSetUnitStake(roundStake((parseFloat(nextProps.betslip.stake) || 0) / getDivisionCoefficient(nextProps.betslip))));
            }
            // --------------------- SUPER BET -------------------------------------------------------------------------
            if (nextProps.user.profile && nextProps.user.profile.super_bet !== undefined && nextProps.user.profile.super_bet !== -1) {
                let superBets = Helpers.objectToArray(nextProps.user.profile.super_bet);
                superBetWatcher(superBets, this.processedSuperBetIds, this.props.dispatch);
            }

            if (Config.betting.enableSuperBet && Object.keys(nextProps.betslip.events).length !== Object.keys(this.props.betslip.events).length &&
                (!Config.betting.allowSuperBetForLive && Object.keys(nextProps.betslip.events).length !== 0 && Helpers.hasLiveGame(Object.values(nextProps.betslip.events)))) {
                this.props.dispatch(BetslipToggleSuperBet(false));
            }

            //TODO: check if event having base was deleted and try to replace it with event from same market having same type and nearest base
        },
        ComponentWillMount: function () {
            this.processedSuperBetIds = {};
            this.swarmDataKey = "betslip";

            if (_.isEmpty(this.props.betslip.events)) return;

            this.swarmSubscriptionRequest = {
                "source": "betting",

                "what": {
                    "game": ["is_blocked"],
                    "event": ["price", "base", "type"]
                },
                "where": {
                    "event": { "id": { "@in": Object.keys(this.props.betslip.events).map(id => parseInt(id, 10)) } },
                    "game": { "id": { "@in": Object.values(this.props.betslip.events).map(x => x.gameId) } }
                }
            };
        }
    }
));
